import { playKdsChime } from "@/lib/kdsAlerts";

const SOUND_KEY = "online_order_sound_alerts";

export function playOnlineOrderChime() {
  playKdsChime();
}

export function loadOnlineOrderSoundEnabled() {
  const v = localStorage.getItem(SOUND_KEY);
  if (v === null) return true;
  return v === "1";
}

export function setOnlineOrderSoundEnabled(enabled) {
  localStorage.setItem(SOUND_KEY, enabled ? "1" : "0");
}
